/* Native drawers and native count updates remain the owners of shopping actions. */
(() => {
  if (customElements.get('hatchill-bottom-nav')) return;
  class BottomNavigation extends HTMLElement {
    connectedCallback() {
      this.cart = this.querySelector('[data-hb-cart]');
      this.search = this.querySelector('[data-hb-search]');
      const feature = this.querySelector('[data-hb-feature]');
      const featureLink = this.querySelector('[data-hb-new-link]');
      const seenDestinations = new Set();
      const slides = Array.from(feature?.querySelectorAll?.('[data-hb-slide]') || []).filter(slide => {
        const key = slide.dataset.hbUrl || slide.querySelector('img')?.getAttribute('src');
        if (key && seenDestinations.has(key)) { slide.hidden = true; return false; }
        if (key) seenDestinations.add(key);
        slide.hidden = false;
        return true;
      });
      const showSlide = active => {
        slides.forEach((slide, index) => slide.classList.toggle('is-active', index === active));
        const { hbUrl, hbTitle } = slides[active]?.dataset || {};
        if (!featureLink || !hbUrl?.startsWith('/') || hbUrl.startsWith('//')) return;
        const destination = new URL(hbUrl, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        featureLink.setAttribute('href', hbUrl);
        featureLink.setAttribute('aria-label', [featureLink.dataset.label, hbTitle].filter(Boolean).join(': '));
        if (destination.pathname === window.location.pathname) featureLink.setAttribute('aria-current', 'page');
        else featureLink.removeAttribute('aria-current');
      };
      if (slides.length) showSlide(0);
      const toggle = this.querySelector('[data-hb-motion-toggle]');
      if (slides?.length > 1 && toggle && typeof window.matchMedia === 'function') {
        let active = 0;
        let paused = false;
        let focused = false;
        let hovered = false;
        let pressed = false;
        let timer;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = window.matchMedia('(max-width: 989px)');
        feature.classList.add('is-rotating');
        this.rotationSync = () => {
          clearInterval(timer);
          const playing = !paused && !focused && !hovered && !pressed && !reduced.matches && mobile.matches && !document.hidden;
          feature.classList.toggle('is-playing', playing);
          toggle.hidden = reduced.matches || !mobile.matches;
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
          if (playing) {
            timer = setInterval(() => {
              active = (active + 1) % slides.length;
              showSlide(active);
            }, 4000);
          }
        };
        this.rotationToggle = () => { paused = !paused; this.rotationSync(); };
        const interactionHandlers = {
          focusin: () => { focused = true; this.rotationSync(); },
          focusout: () => { focused = false; this.rotationSync(); },
          pointerenter: event => { hovered = event.pointerType === 'mouse'; this.rotationSync(); },
          pointerleave: () => { hovered = false; pressed = false; this.rotationSync(); },
          pointerdown: () => { pressed = true; this.rotationSync(); },
          pointerup: () => { pressed = false; this.rotationSync(); },
          pointercancel: () => { pressed = false; this.rotationSync(); }
        };
        Object.entries(interactionHandlers).forEach(([event, handler]) => featureLink?.addEventListener(event, handler));
        toggle.addEventListener('click', this.rotationToggle);
        reduced.addEventListener?.('change', this.rotationSync);
        mobile.addEventListener?.('change', this.rotationSync);
        document.addEventListener('visibilitychange', this.rotationSync);
        this.stopRotation = () => {
          clearInterval(timer);
          Object.entries(interactionHandlers).forEach(([event, handler]) => featureLink?.removeEventListener(event, handler));
          toggle.removeEventListener('click', this.rotationToggle);
          reduced.removeEventListener?.('change', this.rotationSync);
          mobile.removeEventListener?.('change', this.rotationSync);
          document.removeEventListener('visibilitychange', this.rotationSync);
        };
        this.rotationSync();
      }
      this.syncCount = () => {
        const count = this.cart?.querySelector('[data-cart-count]');
        if (count) count.hidden = !(Number.parseInt(count.textContent, 10) > 0);
        const summary = this.cart?.querySelector('[data-cart-text]')?.textContent?.trim();
        if (this.cart && summary) this.cart.setAttribute('aria-label', [this.cart.dataset.cartLabel, summary].filter(Boolean).join(', '));
      };
      this.countObserver = new MutationObserver(this.syncCount);
      if (this.cart) this.countObserver.observe(this.cart, { childList:true, subtree:true, characterData:true });
      this.syncCount();
      const drawer = document.getElementById('Cart-Drawer');
      if (drawer) customElements.whenDefined('cart-drawer').then(() => {
        if (this.isConnected) drawer.setHeaderCartIconAccessibility();
      });
      this.measure = () => {
        const height = getComputedStyle(this).display === 'none' ? 0 : Math.ceil(this.getBoundingClientRect().height + 14);
        document.documentElement.style.setProperty('--hatchill-dock-height', `${height}px`);
        document.body.style.setProperty('--toolbar-mobile-height', `${height}px`);
        document.dispatchEvent(new CustomEvent('hatchill:dock-resize', { detail:{height} }));
      };
      this.inputFocus = () => {
        const active = document.activeElement;
        const typing = active?.matches('textarea,select,input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="hidden"])');
        this.classList.toggle('is-input-focused', Boolean(typing));
        this.measure();
      };
      document.addEventListener('focusin', this.inputFocus);
      document.addEventListener('focusout', this.inputFocus);
      this.resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(this.measure);
      this.resizeObserver?.observe(this);
      window.addEventListener('resize', this.measure);
      this.measure();
    }
    disconnectedCallback() {
      this.stopRotation?.();
      this.countObserver?.disconnect(); this.resizeObserver?.disconnect();
      document.removeEventListener('focusin', this.inputFocus);
      document.removeEventListener('focusout', this.inputFocus);
      window.removeEventListener('resize', this.measure);
      document.documentElement.style.setProperty('--hatchill-dock-height', '0px');
      document.body.style.setProperty('--toolbar-mobile-height', '0px');
    }
  }
  customElements.define('hatchill-bottom-nav', BottomNavigation);
})();
